/* eslint-disable no-unused-vars */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import externalReviewSagas from './external_review/saga';
import upload from './upload/saga';
import dashboard from './dashboard/saga';
import catalogList from './catalogList/saga';
import orp from './orp/saga';
import orpcompras from './orpcompras/saga';
import validateEmailUser from './validate_email/saga';
import basket from './basket_medicine/saga';
import menuRole from './menuRole/saga';
import articleCard from './article_card/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    externalReviewSagas(),
    upload(),
    dashboard(),
    catalogList(),
    orp(),
    orpcompras(),
    validateEmailUser(),
    basket(),
    menuRole(),
    articleCard()
  ]);
}
